import React from 'react';
import exact from 'prop-types-exact';
import PropTypes from 'prop-types';

// The image currently only consist of one or two letters (initials of the user)
// and is either grey or colored with a badge, depending on the PRO status of the user
// The size is controlled via the font size. Not sure if this is smart and if this works well across browsers
// The badgeCentered property also controlls if there will be a hover animation or not (badgeCentered = true -> no hover animation)

const ProfileImage = ({ name, lastName, size, badgeCentered = false, isPro = false }) => {
    const initials = name && name[0].toUpperCase() + (lastName ? lastName[0].toUpperCase() : '');

    return (
        <div className={`profileImage${!badgeCentered ? ' hoverAnimation' : ''}${isPro ? ' isPro' : ''}`} style={{ fontSize: `${size}px` }}>
            {isPro && <div className={`profileImageProBadge${badgeCentered ? ' badgeCentered' : ''}`}>PRO</div>}
            {initials}
        </div>
    );
};

ProfileImage.propTypes = exact({
    name: PropTypes.string.isRequired,
    lastName: PropTypes.string,
    size: PropTypes.number.isRequired,
    badgeCentered: PropTypes.bool,
    isPro: PropTypes.bool,
});

export default ProfileImage;
